import { useTranslation } from 'react-i18next'

import Overlay from 'components/Overlay'
import OverlayModal from 'components/Overlay/OverlayModal'
import useGetProgress from 'lib/hooks/api/useGetProgress'

import Spinner from './Spinner'
import { useAuthContext } from './AuthContextProvider'
import useIsUserAuthorized from './useIsUserAuthorized'
import useResumeWalk from './useResumeWalk'
import useSignIn from './useSignIn'

interface AuthProps {
  walkSlug: string
  shouldResumeProgress?: boolean
}

const Auth: React.FC<AuthProps> = ({
  walkSlug,
  shouldResumeProgress = false,
}) => {
  const { t } = useTranslation()

  const {
    isLoading: isAuthLoading,
    isSignedIn,
    isFreshSession,
  } = useAuthContext()

  const tryToResume = shouldResumeProgress && isFreshSession

  const { data: progressData } = useGetProgress(walkSlug, tryToResume)

  const isUserAuthorized = useIsUserAuthorized(walkSlug)

  const isAuthComplete =
    isSignedIn &&
    !isAuthLoading &&
    isUserAuthorized === true &&
    (!tryToResume || progressData != null)

  const shouldShowOverlay =
    !isAuthComplete || (tryToResume && !!progressData?.ProgressSlug)

  useResumeWalk({
    isAuthComplete,
    tryToResume,
    progressSlug: progressData?.ProgressSlug,
  })

  useSignIn()

  return (
    <Overlay show={shouldShowOverlay}>
      {isUserAuthorized === false ? (
        <OverlayModal
          heading={t('notAuthedModal.header')}
          content={t('notAuthedModal.content')}
          ctaHref={process.env.NEXT_PUBLIC_IWITNESS_DASHBOARD_URL ?? ''}
          ctaText={t('notAuthedModal.cta')}
        />
      ) : (
        <Spinner />
      )}
    </Overlay>
  )
}

export default Auth
